import {ExceptionError} from '../exception'
import {Request} from '../request'
import {IPageOption} from '../../interface/paging/paging'
import {IApiResponse, IBulkTemplateResponse} from '../../interface/api-response/api-response'
import {API_PATH} from '../../constants/api-path'
import {IBulkTagCreate, ITag, ITagCreate, ITagUpdate} from '../../interface/tag'

export class GetTagService extends Request {
  async request(options?: IPageOption) {
    try {
      const {data} = await this.client
        .get<IApiResponse<ITag[]>>(API_PATH.TAG, {
          params: options,
        })
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class GetAvailableTagService extends Request {
  async request(options?: IPageOption, params?: any) {
    try {
      const {data} = await this.client
        .post<IApiResponse<ITag[]>>(`${API_PATH.TAG}/get-available-tag`, params, {
          params: options,
        })
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class CreateTagService extends Request {
  async request(payload: ITagCreate) {
    const {data} = await this.client.post<ITag>(API_PATH.TAG, payload)
    try {
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class UpdateTagService extends Request {
  async request(payload: ITagUpdate) {
    try {
      const {data} = await this.client.patch<ITag>(API_PATH.TAG, payload)
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class GetTagByIdService extends Request {
  async request(id: string) {
    try {
      const {data} = await this.client
        .get<IApiResponse<ITag[]>>(`${API_PATH.TAG}/get-by-id/${id}`)
        .then((d) => d.data)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class GetBrowseTagService extends Request {
  async request(params?: any) {
    // const temp = {...params}
    // if (!temp?.plantIds || temp?.plantIds?.length === 0) {
    //   delete temp.plantIds
    // } else {
    //   temp.plantIds = temp.plantIds.map((el) => {
    //     return el.id
    //   })
    // }
    try {
      const {data} = await this.client
        .post<IApiResponse<any[]>>(`${API_PATH.TAG}/brows-tag?getAll=true`, params)
        .then((d) => d.data)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

class GetBulkTagTemplate extends Request {
  async request(plantId: string, disciplineId?: string) {
    try {
      const qs = !disciplineId
        ? `plantId=${plantId}`
        : `plantId=${plantId}&disciplineId=${disciplineId}`

      const {data} = await this.client
        .get<IApiResponse<IBulkTemplateResponse>>(`${API_PATH.TAG}/bulk-tag?${qs}`)
        .then((d) => d.data.data)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

class CreateBulkTag extends Request {
  async request(payload: IBulkTagCreate) {
    try {
      await this.client.post(`${API_PATH.TAG}/bulk-tag`, payload)
    } catch (error: any) {
      const errMsg: any = !error.response.data?.errors
        ? error.response.data.message
        : `<div style="text-align: left;">${error.response.data.errors
            .map((e) => `<li>${e}</li>`)
            .join('')}</div>`

      throw new ExceptionError({message: errMsg} as any)
    }
  }
}
export class UploadBulkTag extends Request {
  async request(payload: any) {
    try {
      await this.client.post(`${API_PATH.TAG}/bulk-tag/file`, payload)
    } catch (error: any) {
      const errMsg: any = !error.response.data?.errors
        ? error.response.data.message
        : `<div style="text-align: left;">${error.response.data.errors
            .map((e) => `<li>${e}</li>`)
            .join('')}</div>`

      throw new ExceptionError({message: errMsg} as any)
    }
  }
}
export class GetTagLogService extends Request {
  async request(params: any) {
    try {
      const {data} = await this.client
        .get<IApiResponse<any>>(`${API_PATH.TAG}/get-log/${params.id}`, {params})
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class GetTagHistoryBulkService extends Request {
  async request(params: any) {
    try {
      const {data} = await this.client
        .get<IApiResponse<any>>(`${API_PATH.TAG}/bulk-tag/file`, {params})
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class DownloadTagHistoryBulkService extends Request {
  async request(id: string) {
    try {
      const {data} = await this.client
        .get<any>(`${API_PATH.TAG}/bulk-tag/file/${id}`, {
          responseType: 'blob', // Important: set response type to blob
        })
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class ExportEngineeringService extends Request {
  async request(id: string) {
    try {
      const {data} = await this.client
        .get<any>(`${API_PATH.TAG}/engineering-doc/${id}`, {})
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export const uploadBulkTag = new UploadBulkTag()
export const createBulkTag = new CreateBulkTag()
export const getBulkTagTemplate = new GetBulkTagTemplate()
